import React, { useEffect, useState } from 'react'
import { Form, Input, InputNumber, Radio } from 'antd'
import { Modal } from '@/components/dialog/modal'
import $msg from '@/utils/message'
import { editMemberPoint } from '../api'

interface ChangePointsForm {
    type: 1 | -1
    points: number
    remark?: string
}

interface Props {
    visible: boolean
    memberId: number
    currentPoints: number
    onCancel: () => void
    onSuccess: () => void
}

const ChangePointsModal: React.FC<Props> = props => {
    const [form] = Form.useForm<ChangePointsForm>()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!props.visible) return

        form.setFieldsValue({ type: 1, points: undefined, remark: '' })
    }, [form, props.visible])

    const onSubmit = async () => {
        try {
            const values = await form.validateFields()
            setLoading(true)
            await editMemberPoint({
                member_id: props.memberId,
                change_points: values.type * values.points,
                remark: values.remark,
            })
            $msg('success', '调整积分成功')
            props.onSuccess()
        } catch (e) {
            if (e && e.errorFields) return
            $msg('error', e.message || '调整积分失败')
        } finally {
            setLoading(false)
        }
    }

    return props.visible ? (
        <Modal
            title="调整积分"
            isShow
            type="success"
            loading={loading}
            onConfirm={onSubmit}
            onClose={props.onCancel}
            onCancel={props.onCancel}
            okText="确认"
            cancelText="取消"
        >
            <div className="member-detail__modal-tip">当前积分：{props.currentPoints || 0}</div>
            <Form form={form} layout="vertical" initialValues={{ type: 1 }}>
                <Form.Item name="type" label="调整方式" rules={[{ required: true, message: '请选择调整方式' }]}>
                    <Radio.Group>
                        <Radio value={1}>增加积分</Radio>
                        <Radio value={-1}>扣减积分</Radio>
                    </Radio.Group>
                </Form.Item>
                <Form.Item noStyle shouldUpdate={(prev, next) => prev.type !== next.type}>
                    {() => (
                        <Form.Item
                            name="points"
                            label="调整积分"
                            rules={[
                                { required: true, message: '请输入调整积分' },
                                {
                                    validator: (_, value) => {
                                        if (form.getFieldValue('type') === -1 && value > props.currentPoints) {
                                            return Promise.reject(new Error('扣减积分不能超过当前积分'))
                                        }

                                        return Promise.resolve()
                                    },
                                },
                            ]}
                        >
                            <InputNumber
                                min={1}
                                max={form.getFieldValue('type') === -1 ? props.currentPoints : undefined}
                                precision={0}
                                style={{ width: '100%' }}
                                placeholder="请输入调整积分"
                            />
                        </Form.Item>
                    )}
                </Form.Item>
                <Form.Item name="remark" label="备注" rules={[{ max: 100, message: '备注最多100个字' }]}>
                    <Input.TextArea rows={3} placeholder="请输入备注" />
                </Form.Item>
            </Form>
        </Modal>
    ) : null
}

export default ChangePointsModal
